module.exports = __webpack_public_path__ + "img/games-16.66af0863.webp";